import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  LinearProgress,
  Skeleton,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import React, { useEffect, useState } from 'react';
import Rating from '@mui/material/Rating';
import './Product.css';
import './CarouselItem.css';
import { useDispatch } from 'react-redux';
import { manipulateCart } from '../../Redux/AddToCart/Cart-Action';
import { REMOVE_ITEM } from '../../Redux/AddToCart/Cart-Constants';
import { useNavigate } from 'react-router-dom';
import { manipulateWishList } from '../../Redux/AddToWishlist/Wishlist-Action';
import { manipulateEditCourse } from '../../Redux/EditCourse/EditCourse-Action';
import {
  ADD_EDIT_COURSE,
  REMOVE_EDITABLE_COURSE,
} from '../../Redux/EditCourse/EditCourse-Constants';
import defaultImage from '../../assets/CourseImages/Thumbnail.webp';
import { courseStageAPI } from '../../api/requests/courses/courseStageAPI';
import { courseAPI } from '../../api/requests/courses/courseAPI';
import GetValidatedTokenData from '../../utils/helper';
import { handleAlert } from '../../utils/handleAlert';
import ManageCourseAccess from '../../pages/Courses/ManageCourseAccess';
import ButtonAddAccess from '../SearchAndAdd/ButtonAddAccess';
import { getOrgName } from '../../utils/appendOrgQuery';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import ManageAccountsOutlined from '@mui/icons-material/ManageAccountsOutlined';
import { useAppTheme } from '../../theme/ThemeProvider/AppTheme';
import { RoundedButton } from '../Form';
const CarouselItem = ({
  ProductDetails,
  keyfrombackend,
  loading,
  isEditable,
  isUserProfileInProduct,
  domainData,
  getCourses,
  forSuggestedOrgPopup,
  currentPage,
  activeTab,
}) => {

  const { getColor } = useAppTheme()

  const [isHovered, setIsHovered] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [openManageAccessDialog, setOpenManageAccessDialog] = React.useState(false);
  const [isEnrolled, setHasEnrolled] = useState(false);
  const [isEditor, setIsEditor] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currUser = GetValidatedTokenData();
  const orgPath = getOrgName();

  const getdata = () => {
    if (ProductDetails.courseStage === 'ENROLLED') {
      setHasEnrolled(true);
    }
    if (ProductDetails.courseStatus === 'EDIT') {
      setIsEditor(true);
    }

    if (
      Object.prototype.hasOwnProperty.call(ProductDetails, 'courseStage') &&
      Object.prototype.hasOwnProperty.call(ProductDetails, 'courseStatus')
    ) {
      return;
    }
  };

  const updateState = (data) => {
    setHasEnrolled(data.data.courseStage === 'ENROLLED');
    setIsEditor(data.data.courseStatus === 'EDIT');
  };

  useEffect(() => {
    const getCourseData = async () => {
      await getdata();
    };
    getCourseData();
  }, []);

  const handleRemoveEnrolledCourse = async (id) => {
    await courseStageAPI
      .removeFromEnrolledCourses(id)
      .then((data) => { })
      .then((data) => { })
      .catch((err) => {
        dispatch(manipulateCart(REMOVE_ITEM, id));
      });
  };

  const handleClose = (_, reason) => {
    if (reason && reason === 'backdropClick') return;
    setIsHovered(false);
  };

  const isCurrentUser = (userId) => {
    return GetValidatedTokenData().id === userId;
  };

  const handleGoToDetailPage = (id, userId, orgName) => {
    if (isCurrentUser(userId)) navigate(`/org/${orgName}/course/videos/${id}`);
    else if (ProductDetails?.status === 'UNDERREVIEW') navigate('/under-review');
    else if (ProductDetails?.status === 'APPROVED') navigate(`/org/${orgPath}/course/videos/${id}`);
    else if (ProductDetails?.courseStage === 'ENROLLED')
      navigate(`/org/${orgPath}/course/videos/${id}`);
  };

  const handleEditCourse = (ProductDetails) => {
    dispatch(manipulateEditCourse(ADD_EDIT_COURSE, ProductDetails?.id));
  };

  const handleDeleteDialog = () => {
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setIsHovered(false);
  };

  const handleManageAccessDialog = () => {
    setOpenManageAccessDialog(true);
  };

  const handleCloseManageAccessDialog = () => {
    setOpenManageAccessDialog(false);
    setIsHovered(false);
  };

  const handleDeleteCourse = async (ProductDetails) => {
    await courseAPI
      .deleteCourse(ProductDetails.id)
      .then((res) => {
        dispatch(manipulateWishList(REMOVE_EDITABLE_COURSE, ProductDetails.id));
        handleAlert(res?.data?.message, 'success');
        setOpenDeleteDialog(false);
        getCourses(currentPage, activeTab);
      })
      .catch((err) => {
        handleAlert(err?.message, 'error');
      });
  };
  return (
    <>
      <div
        className="Container"
        key={keyfrombackend}
        data-user-profile={isUserProfileInProduct || undefined}
      >
        <Box
          sx={{
            backgroundColor: 'var(--color-bg-secondary)',
            backdropFilter: 'blur(10px)',
            borderRadius: '12px',
            border: '1px solid var(--color-border)',
            height: 'auto',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: `0px 4px 10px ${getColor('text', 0.1)}`,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            position: 'relative',
            overflow: 'hidden',
            '&:hover': {
              transform: 'translateY(-2px) scale(1.02)',
            },
            boxShadow: `0px 4px 10px ${getColor('text', 0.1)}`,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {loading ? (
            <Skeleton variant="rectangular" width={300} height={240} />
          ) : (
            <img
              style={{
                width: '100%',
                height: '150px',
                minHeight: '150px',
                objectFit: 'cover',
                borderRadius: '12px 12px 0px 0px',
                cursor: 'pointer',
                transition: 'transform 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
              }}
              alt={ProductDetails?.title}
              src={ProductDetails?.imageUrl ?? defaultImage}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = defaultImage;
              }}
              onClick={() =>
                handleGoToDetailPage(
                  ProductDetails?.id,
                  ProductDetails?.userId,
                  ProductDetails?.orgName
                )
              }
            />
          )}

          {ProductDetails ? (
            <>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  p: 1.5,
                  pb: 0,
                  alignItems: 'stretch',
                }}
              >
                <Box
                  style={{ cursor: 'pointer', height: '100%' }}
                  onClick={() =>
                    handleGoToDetailPage(
                      ProductDetails?.id,
                      ProductDetails?.userId,
                      ProductDetails?.orgName
                    )
                  }
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: '600',
                        fontFamily: 'Poppins',
                        display: '-webkit-box!important',
                        WebkitLineClamp: 1,
                        wordBreak: 'break-all',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        WebkitBoxOrient: ' vertical',
                        mb: 0.5,
                        mt: 0,
                        fontSize: '1rem',
                        lineHeight: 1.3,
                        fontSize: '1rem',
                        lineHeight: 1.3,
                      }}
                    >
                      {ProductDetails.title}
                    </Typography>
                    <Typography
                      display="block"
                      variant="caption"
                      sx={{
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        lineHeight: 1.4,
                        display: '-webkit-box!important',
                        WebkitLineClamp: 1,
                        overflow: 'hidden',
                        WebkitBoxOrient: ' vertical',
                        color: 'var(--color-text-secondary)',
                      }}
                    >
                      {`${ProductDetails?.authorData?.firstName} ${ProductDetails?.authorData?.lastName}`}
                    </Typography>
                    {isUserProfileInProduct === true ? (
                      <Typography display="block" variant="caption" color="text.secondary">
                        {ProductDetails?.status}
                      </Typography>
                    ) : (
                      <></>
                    )}
                  </Box>

                  <Box
                    sx={{
                      mt: 0.5,
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <Typography
                        sx={{ mr: 0.5, fontWeight: '500', fontSize: '13px' }}
                        variant="caption"
                        color="var(--color-warning)"
                      >
                        {ProductDetails?.rating?.rating}
                      </Typography>
                      <Stack spacing={1} sx={{ mr: 0.5 }}>
                        <Rating
                          sx={{
                            fontSize: '14px',
                            '& .MuiRating-iconFilled': {
                              color: 'var(--color-warning)',
                            }
                          }}
                          name="half-rating"
                          defaultValue={ProductDetails?.rating?.rating}
                          precision={1}
                          readOnly
                        />
                      </Stack>
                      <Typography variant="caption" color="text.secondary">
                        {` (${ProductDetails?.rating?.ratedBy})`}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '12px',
                      rowGap: '6px',
                      mt: 1,
                      mb: 1,
                      padding: '8px 12px',
                      borderRadius: '8px',
                      backgroundColor: 'var(--color-bg)',
                      border: `1px solid var(--color-border)`,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        lineHeight: 1.2,
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2px',
                        fontWeight: 500,
                      }}
                    >
                      <OndemandVideoIcon sx={{ fontSize: '16px', color: 'var(--color-primary)' }} />
                      {`Videos: ${ProductDetails?.videosCount ?? 0}`}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        lineHeight: 1.2,
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2px',
                        fontWeight: 500,
                      }}
                    >
                      <FolderOpenIcon sx={{ fontSize: '16px', color: 'var(--color-primary)' }} />{' '}
                      {`Sections: ${ProductDetails?.sectionsCount ?? 0}`}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        lineHeight: 1.2,
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2px',
                      }}
                    >
                      <TaskOutlinedIcon sx={{ fontSize: '16px', color: 'var(--color-primary)' }} />
                      {`Tasks: ${ProductDetails?.tasksCount ?? 0}`}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        lineHeight: 1.2,
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2px',
                        fontWeight: 500,
                      }}
                    >
                      <EmojiEventsOutlinedIcon sx={{ fontSize: '16px', color: 'var(--color-primary)' }} />
                      {`Contests: ${ProductDetails?.contestsCount ?? 0}`}
                    </Typography>
                  </Box>
                </Box>
                {forSuggestedOrgPopup ? (
                  <></>
                ) : (
                  <Box>
                    {!domainData && ProductDetails?.courseStage !== 'ENROLLED' ? (
                      <Box>                        {isEditable ? (
                        <Box mt={2} mb={2} display={'flex'} flexDirection="column" gap="16px">
                          <RoundedButton
                            fullWidth
                            variant="outlined"
                            startIcon={<ManageAccountsOutlined />}
                            onClick={() => {
                              navigate(
                                `/org/${ProductDetails.orgName}/course/enrollment-management/${ProductDetails.id}`
                              );
                            }}
                          >
                            Manage Course
                          </RoundedButton>
                        </Box>
                      ) : (
                        <></>
                      )}
                      </Box>
                    ) : (
                      null
                    )}

                    <Dialog
                      open={openDeleteDialog}
                      onClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">
                        {'Do you really want to delete?'}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          this course will delete permanently
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => handleDeleteCourse(ProductDetails)}>Yes</Button>
                        <Button onClick={handleCloseDeleteDialog}>Cancel</Button>
                      </DialogActions>
                    </Dialog>
                    <Dialog
                      open={openManageAccessDialog}
                      onClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">
                        {'Give course access permissions'}
                      </DialogTitle>
                      <DialogContent>
                        <ManageCourseAccess courseId={keyfrombackend} handleClose={handleClose} />
                      </DialogContent>
                      <DialogActions
                        sx={{
                          mt: -2,
                          display: 'flex',
                          justifyContent: 'space-between',
                          mx: 2,
                        }}
                      >
                        <ButtonAddAccess
                          courseId={keyfrombackend}
                          setOpenManageAccessDialog={setOpenManageAccessDialog}
                        />
                        <Button onClick={handleCloseManageAccessDialog}>Cancel</Button>
                      </DialogActions>
                    </Dialog>
                  </Box>
                )}
              </Box>
            </>
          ) : (
            <Box sx={{ pt: 0.5 }}>
              <Skeleton />
              <Skeleton width="60%" />
            </Box>
          )}

          {ProductDetails?.courseStage === 'ENROLLED' && ProductDetails?.courseCompletion !== undefined && (
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              px: 1.5,
              pb: 1.5,
              mt: 1,
            }}>
              <LinearProgress
                variant="determinate"
                value={Math.min(ProductDetails.courseCompletion, 100)}
                sx={{
                  height: '6px',
                  backgroundColor: 'var(--color-primary)',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: 'var(--color-primary)',
                  },
                  borderRadius: '4px',
                  flexGrow: 1,
                  boxShadow: '0 1px 3px rgba(105, 138, 255, 0.2)',
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  fontWeight: '600',
                  fontSize: '12px',
                  color: 'var(--color-primary)',
                  minWidth: '35px',
                  textAlign: 'right',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  backgroundColor: 'rgba(105, 138, 255, 0.1)',
                }}
              >
                {Math.min(ProductDetails.courseCompletion, 100)}%
              </Typography>
            </Box>
          )}

        </Box>
      </div>
    </>
  );
};

export default React.memo(CarouselItem);
